import axios from '@/utils/axios'
import urlConfig from '@/utils/urlConfig'

export default {
  // 第三方接口记录-分页查询
  thirdApiRecordPageApi: (data) =>
    axios.apiPost(urlConfig.busiURL + '/scfs/api/page', data),

  // 第三方接口记录-详情
  thirdApiRecordDetailApi: (id) =>
    axios.apiPost(urlConfig.busiURL + '/scfs/api/detail', { id }),

  // 第三方接口记录-API枚举列表
  thirdApiRecordApiEnumsApi: () =>
    axios.apiGet(urlConfig.busiURL + '/scfs/api/api-enums'),
}
